import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { spotFinder } from './endpoints';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';

// Define a service using a base URL and expected endpoints
export const citiesApi = createApi({
  reducerPath: 'citiesApi',
  baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
  tagTypes: ['cities'],
  endpoints: (builder) => ({
    getAllCities: builder.mutation({
      query(body) {
        return {
          url: spotFinder.cityController.getAllCities,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    addCityData: builder.mutation({
      query(body) {
        return {
          url: spotFinder.cityController.addCityData,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    updateCityData: builder.mutation({
      query(body) {
        return {
          url: spotFinder.cityController.updateCityData,
          method: 'PUT',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    deleteCityData: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.cityController.deleteCityData}`,
          method: 'DELETE',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    uploadCityImage: builder.mutation({
      query(body) {
        return {
          url: spotFinder.cityController.uploadCityImage,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
  }),
});

export const {
  useAddCityDataMutation,
  useUpdateCityDataMutation,
  useGetAllCitiesMutation,
  useDeleteCityDataMutation,
  useUploadCityImageMutation,
} = citiesApi;
